import { Tooltip } from "react-tooltip";

type TruncatedTextProps = {
  text: string;
  maxLength?: number;
  id: string;
  externalClassNames?: string;
};

export const TruncatedText = ({
  text,
  maxLength = 30,
  id,
  externalClassNames = "cursor-pointer",
}: TruncatedTextProps) => {
  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? `${text.slice(0, maxLength)}...` : text;

  return (
    <>
      <span data-tooltip-id={id} className={externalClassNames}>
        {displayText}
      </span>
      {isTruncated && (
        <Tooltip id={id} place="bottom" content={text} className="z-10" />
      )}
    </>
  );
};
